(function () {
  const SEL = {
    wrap: '[data-age-check]',
    box: '[data-age-check-input]',
    error: '[data-age-check-error]',
    clear: '[data-age-check-clear]',
    checkout: '#checkout-submit, button[name="checkout"], input[name="checkout"]',
    agree: 'input#x-cart-agree.hidden'
  };

  let attempted = false;

  const debounce = (fn, ms = 80) => { let t; return () => { clearTimeout(t); t = setTimeout(fn, ms); }; };
  const required = () => !!document.querySelector(SEL.wrap);
  const isConfirmed = () => [...document.querySelectorAll(SEL.box)].some(b => b.checked);

  function push(value) {
    return fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Altersbestätigung': value } })
    }).catch(() => {});
  }

  function scope() {
    return document.querySelectorAll('#main-cart-items, #main-cart-footer, #CartDrawer');
  }

  function sync() {
    const need = required();
    const ok = !need || isConfirmed();

    scope().forEach(root => {
      root.querySelectorAll(SEL.agree).forEach(a => { a.checked = ok; });
      root.querySelectorAll('.additional-checkout-buttons').forEach(el => {
        el.style.display = ok ? '' : 'none';
      });
    });

    document.querySelectorAll(SEL.error).forEach(p => { p.hidden = ok || !attempted; });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest(SEL.checkout);
    if (!btn) return;
    if (!required() || isConfirmed()) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    attempted = true;
    sync();
    const box = document.querySelector(SEL.box);
    if (box) {
      box.focus();
      box.closest(SEL.wrap).scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, true);

  document.addEventListener('change', function (e) {
    const box = e.target.closest(SEL.box);
    if (!box) return;
    attempted = true;
    document.querySelectorAll(SEL.box).forEach(b => { b.checked = box.checked; });
    sync();
    push(box.checked ? 'bestätigt (18+)' : '');
  });

  function clearStale() {
    if (document.querySelector(SEL.clear)) push('');
  }

  const refresh = debounce(function () { sync(); clearStale(); });
  new MutationObserver(refresh).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', refresh);
  refresh();
})();